<template>
  <div class="modal modal-message">
    <div class="content">
      <h1>{{ message.title }}</h1>
      <p class="body" v-html="message.body"></p>
      <div class="modal-action">
        <button
          v-if="message.actionButton"
          class="modal_action_button"
          @click="handleAction(message.actionButton.action)"
        >
          {{ message.actionButton.text || 'Okay!' }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { watch, onUnmounted } from 'vue';
import { useModalStore } from '@/stores/modalStore';
import { useGamePlayStore } from '@/stores/gamePlayStore';
import { useGameAudioStore } from '@/stores/gameAudioStore';

const SHARED_AUDIO = '/assets/games/audio/shared';

const props = defineProps({
  message: {
    type: Object,
    required: true,
  },
  isLevelUpModal: {
    type: Boolean,
    default: false,
  },
});

const modalStore = useModalStore();
const gamePlayStore = useGamePlayStore();
const gameAudio = useGameAudioStore();

// Play shared lifecycle voice-over when modal appears with a recognized title
watch(
  () => props.message.title,
  (title) => {
    if (!title || typeof title !== 'string') return;

    if (title.startsWith('End of Round')) {
      gameAudio.playSpeech(`${SHARED_AUDIO}/end-of-round.mp3`);
    } else if (title === 'Level Up!') {
      gameAudio.playSpeech(`${SHARED_AUDIO}/amazing-job-level-up.mp3`);
    } else if (title === 'Congratulations!') {
      gameAudio.playSpeech(`${SHARED_AUDIO}/game-completed.mp3`);
    }
  },
  { immediate: true }
);

onUnmounted(() => {
  gameAudio.stopSpeech();
});

async function handleAction(action) {
  // Hide the modal immediately for instant feedback
  if (props.isLevelUpModal) {
    console.log('Hiding level up modal');
    modalStore.hideLevelUpModal();
  } else {
    modalStore.hideModal();
  }

  // Execute the action after hiding the modal
  try {
    if (typeof action === 'function') {
      // Don't await - let it run asynchronously
      action();
    }
  } catch (error) {
    console.error('Modal action failed:', error);
  }
}
</script>
